const requireAll = (requireContext) => requireContext.keys().map(requireContext);
const req = require.context('./svg', false, /\.svg$/);
const req2 = require.context('./icon', false, /\.svg$/);
requireAll(req);
requireAll(req2);
